<template>
  <div>
    <header id="mainHeader">
          <div class="container-fluid row align-items-center justify-content-end m-0 p-0 h-100">
              <div class="col-auto p-0">
                <div class="d-flex align-items-center">
                    <p class="text-right m-0">
                      <small>{{ date }}<br/>{{ time }}</small>
                    </p>
                </div>
              </div>
          </div>
    </header>
    <router-view/>
  </div>
</template>
<script>
const dateOpts = { weekday: 'long', month: 'long', day: 'numeric' };
const timeOpts = { hour: '2-digit', minute: '2-digit' };
export default {
  async created() {
    setInterval(() => {
      this.date = new Date().toLocaleDateString('fr-FR', dateOpts);
      this.time = new Date().toLocaleTimeString('fr-FR', timeOpts).replace(':', 'H');
    }, 5000);
  },
  data() {
    return {
      date: new Date().toLocaleDateString('fr-FR', dateOpts),
      time: new Date().toLocaleTimeString('fr-FR', timeOpts).replace(':', 'H'),
    };
  },
};
</script>
